export default __webpack_public_path__ + "static/media/icons8-info.4ec05d1f.svg";